
import logger from './logger'

export {
  logger,
}



/** WEBPACK FOOTER **
 ** ./middleware/index.js
 **/


/** WEBPACK FOOTER **
 ** ./middleware/index.js
 **/